module.exports = __webpack_public_path__ + "img/swiper7.cddcfa5d.jpg";